import { useEffect, useState } from "react";

const useGetLocation = () => {

    const [userLocation, setUserLocation] = useState({});
    // userLocation format
    // {
    //   lat: 26.218287,
    //   lng: 78.182831,
    // }

    useEffect(() => {
      //Location setting
      if (navigator.geolocation) {
        //user browser supports geoloaction api

        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            setUserLocation({ lat: latitude, lng: longitude });
            console.log(position.coords)
          },
          (error) => {
            console.log("Error getting user location", error);
          }
        );
      } else {
          //For testing purpose, mocking location to be able to run tests in jsdom environment
          //as it will not be supporting geoLocation api
          setUserLocation({
            lat: 26.218287,
            lng: 78.182831,
          });

          console.error("Geolocation is not supported by this browser.");
      }
    }, [])

    return userLocation;
}

export default useGetLocation;